// Constantes compartidas para estatus / pipeline / scoring de leads.
// Centralizado para evitar divergencias entre Leads, Kanban, LeadDetail y Dashboard.

export const STATUS_ORDER = [
  "nuevo",
  "contactado",
  "seguimiento",
  "cotizacion_enviada",
  "visita_agendada",
  "negociacion",
  "anticipo_recibido",
  "ganado",
  "perdido",
];

export const STATUS_LABELS = {
  nuevo: "Nuevo",
  contactado: "Contactado",
  seguimiento: "Seguimiento",
  cotizacion_enviada: "Cot. enviada",
  visita_agendada: "Visita agendada",
  negociacion: "Negociación",
  anticipo_recibido: "Anticipo",
  ganado: "Ganado",
  perdido: "Perdido",
};

// Badge styles (usados en tablas/detalle). Mantenemos colores de marca pero agregamos
// tonos distintivos para los nuevos estados.
export const STATUS_BADGE = {
  nuevo: "bg-orange-100 text-orange-800 border-orange-200",
  contactado: "bg-blue-100 text-blue-800 border-blue-200",
  seguimiento: "bg-yellow-100 text-yellow-800 border-yellow-200",
  cotizacion_enviada: "bg-purple-100 text-purple-800 border-purple-200",
  visita_agendada: "bg-indigo-100 text-indigo-800 border-indigo-200",
  negociacion: "bg-pink-100 text-pink-800 border-pink-200",
  anticipo_recibido: "bg-emerald-100 text-emerald-800 border-emerald-200",
  ganado: "bg-green-100 text-green-800 border-green-200",
  perdido: "bg-neutral-100 text-neutral-700 border-neutral-200",
};

// Accent para columnas del Kanban (borde superior y badge de total)
export const STAGE_ACCENT = {
  nuevo: "border-t-orange-500 bg-orange-50/60",
  contactado: "border-t-blue-500 bg-blue-50/60",
  seguimiento: "border-t-yellow-500 bg-yellow-50/60",
  cotizacion_enviada: "border-t-purple-500 bg-purple-50/60",
  visita_agendada: "border-t-indigo-500 bg-indigo-50/60",
  negociacion: "border-t-pink-500 bg-pink-50/60",
  anticipo_recibido: "border-t-emerald-500 bg-emerald-50/60",
  ganado: "border-t-green-600 bg-green-50/60",
  perdido: "border-t-neutral-400 bg-neutral-100/60",
};

export const SOURCE_LABELS = {
  cotizacion: "Cotización",
  catalogo: "Catálogo",
  whatsapp: "WhatsApp",
  directo: "Directo",
};

export const LOSS_REASONS = [
  { value: "precio", label: "Precio" },
  { value: "timing", label: "Timing / momento" },
  { value: "eligio_competencia", label: "Eligió competencia" },
  { value: "no_calificado", label: "No calificado" },
  { value: "no_responde", label: "No responde" },
  { value: "proyecto_cancelado", label: "Proyecto cancelado" },
  { value: "fuera_de_zona", label: "Fuera de zona" },
  { value: "otro", label: "Otro" },
];

// Temperatura del lead (HOT/WARM/COLD). Pill compacta.
export function tempBadgeClass(temp) {
  if (temp === "hot") return "bg-red-600 text-white";
  if (temp === "warm") return "bg-amber-500 text-white";
  return "bg-neutral-300 text-neutral-800";
}

export function tempLabel(temp) {
  if (temp === "hot") return "HOT";
  if (temp === "warm") return "WARM";
  return "COLD";
}
